import {Field} from "./Field";
import EvoSelect from "../../components/form/fields/EvoSelect";
import {mix} from "mixwith";
import {OptionMixin, ClassOptionMixin} from "./Mixins/OptionMixin";
import {PlaceholderMixin, ClassPlaceholderMixin} from "./Mixins/PlaceholderMixin";

/**
 * @extends Field
 * @extends ClassOptionMixin
 * @extends ClassPlaceholderMixin
 */
export class Select extends mix(Field).with(OptionMixin, PlaceholderMixin) {
    constructor() {
        super();
        this._component = EvoSelect;
    }
}
